import { apiFetch } from './apiClient.js';

/**
 * #161 — Sync de templates con Meta Graph / 360dialog. Backend en
 * services/tenant-mgmt/src/handlers/providerTemplates.ts (#92).
 */

export interface ProviderTemplate {
  name: string;
  status: string;
  language: string;
  id?: string;
  components?: Array<Record<string, unknown>>;
  category?: string;
}

interface ListResponse {
  items: ProviderTemplate[];
}

export async function listProviderTemplates(
  tenantId: string,
  connectorId: string,
): Promise<ProviderTemplate[]> {
  const res = await apiFetch<ListResponse>(
    `/v1/tenants/${encodeURIComponent(tenantId)}/connectors/${encodeURIComponent(connectorId)}/provider-templates`,
  );
  return res.items ?? [];
}

export async function createProviderTemplate(
  tenantId: string,
  connectorId: string,
  template: Record<string, unknown>,
): Promise<{ id?: string }> {
  return apiFetch<{ id?: string }>(
    `/v1/tenants/${encodeURIComponent(tenantId)}/connectors/${encodeURIComponent(connectorId)}/provider-templates`,
    { method: 'POST', body: template },
  );
}

export async function deleteProviderTemplate(
  tenantId: string,
  connectorId: string,
  name: string,
): Promise<void> {
  await apiFetch<void>(
    `/v1/tenants/${encodeURIComponent(tenantId)}/connectors/${encodeURIComponent(connectorId)}/provider-templates/${encodeURIComponent(name)}`,
    { method: 'DELETE' },
  );
}
